import {ReactNode} from 'react';
import {CarinaProvider} from './carina';
import {FeatureFlagsProvider} from './lib/feature-flags-context';
import {AccountSignupProvider} from './contexts/AccountSignupContext';

export const AppProviders = ({children}: {children: ReactNode}) => {
  return (
    <CarinaProvider>
      <FeatureFlagsProvider>
        <AccountSignupProvider>{children}</AccountSignupProvider>
      </FeatureFlagsProvider>
    </CarinaProvider>
  );
};
